import React, { useState } from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { copyToClipboard } from './paymentFormUtils';
import { useBrandRegistrationCopy } from '../../../brands/registrationCopy';

interface EventQuickLinksProps {
  eventPageUrl: string;
  registrationUrl: string;
}

interface QuickCopyButtonProps {
  label: string;
  description: string;
  url: string;
}

const QuickCopyButton: React.FC<QuickCopyButtonProps> = ({ label, description, url }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!url) return;
    await copyToClipboard(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant="outlined"
      fullWidth
      onClick={handleCopy}
      disabled={!url}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
        py: 1.5,
        px: 2,
        textTransform: 'none',
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, pr: 1 }}>
        <Typography variant="body2" fontWeight={600}>
          {label}
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          {description}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, color: copied ? 'success.main' : 'primary.main' }}>
        {!copied && <ContentCopyIcon sx={{ fontSize: 18 }} />}
        <Typography variant="caption" fontWeight={600}>
          {copied ? 'Copiado!' : 'Copiar'}
        </Typography>
      </Box>
    </Button>
  );
};

const EventQuickLinks: React.FC<EventQuickLinksProps> = ({ eventPageUrl, registrationUrl }) => {
  const t = useBrandRegistrationCopy();
  return (
    <Paper variant="outlined" sx={{ p: 2, bgcolor: 'grey.50' }}>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Divulgação geral
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
        {t('Links simples para postar o evento — sem desconto e sem rastrear de onde veio a inscrição.')}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <QuickCopyButton
          label="Página do evento"
          description={t('Informações e botão de inscrição')}
          url={eventPageUrl}
        />
        <QuickCopyButton
          label={t('Inscrição aberta')}
          description="Participante escolhe o ingresso"
          url={registrationUrl}
        />
      </Stack>
    </Paper>
  );
};

export default EventQuickLinks;
